module.exports = __webpack_public_path__ + "static/media/background-01.42a6147e.svg";